var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V6L10 0ZM14 18H2V2H10V6H14V18ZM8 15C6.9 15 6 14.1 6 13V7.5C6 7.22 6.22 7 6.5 7C6.78 7 7 7.22 7 7.5V13H9V7.5C9 6.12 7.88 5 6.5 5C5.12 5 4 6.12 4 7.5V13C4 15.21 5.79 17 8 17C10.21 17 12 15.21 12 13V9H10V13C10 14.1 9.1 15 8 15Z",
    fill: "#3E72DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileClip);
export default __webpack_public_path__ + "static/media/FileClip.a8b596c6bd86bab0728bf3e5540f5f3a.svg";
export { ForwardRef as ReactComponent };